/* SUPERMOTO GANG — collection : onglets sous-catégories, filtres, aperçu rapide. */
(function(){
  var grid=document.getElementById('grid'); if(!grid) return;
  var items=[].slice.call(grid.querySelectorAll('.pcard'));
  var tabsEl=document.getElementById('tabs');
  var countEl=document.getElementById('count'), emptyEl=document.getElementById('empty'), loadmore=document.getElementById('loadmore');
  var afbar=document.getElementById('afbar'), fbtn=document.getElementById('openFilter');
  var COLORMAP={noir:'#0A0A0B',os:'#ECE8DE',blanc:'#F4F4F2','noir-blanc':'#0A0A0B',rose:'#EBA8C8',bleu:'#2F6FE3',violet:'#7A3FD0',fume:'#3A3A3E',gris:'#9A9CA1',clair:'#D8D2E8'};
  var COLORLABEL={noir:'Noir',os:'Os',blanc:'Blanc','noir-blanc':'Noir & Blanc',rose:'Rose',bleu:'Bleu',violet:'Violet',fume:'Fumé',gris:'Gris',clair:'Clair'};
  var SIZEORDER=['XS','S','M','L','XL','XXL','TU'];

  var PAGE_ALL=99999; /* SMG : afficher tous les produits d'emblée, sans bouton « charger plus » */
  var cat='all', sortV='default', shown=PAGE_ALL;
  var F={size:new Set(),color:new Set(),price:new Set()};

  /* ---- construire les chips depuis les produits présents ---- */
  (function buildChips(){
    var colors={}, sizes={};
    items.forEach(function(el){
      if(el.dataset.color) colors[el.dataset.color]=true;
      (el.dataset.sizes||'').split(',').forEach(function(s){ if(s) sizes[s.trim()]=true; });
    });
    var sizeChips=document.getElementById('sizeChips'), colorChips=document.getElementById('colorChips');
    var sizeKeys=Object.keys(sizes).sort(function(a,b){ var ia=SIZEORDER.indexOf(a),ib=SIZEORDER.indexOf(b); return (ia<0?99:ia)-(ib<0?99:ib); });
    sizeChips.innerHTML=sizeKeys.map(function(s){ return '<span class="chip" data-v="'+s+'">'+(s==='TU'?'Taille unique':s)+'</span>'; }).join('');
    colorChips.innerHTML=Object.keys(colors).map(function(c){ return '<span class="chip" data-v="'+c+'">'+(COLORLABEL[c]||c)+'</span>'; }).join('');
  })();

  function inPrice(p){ if(F.price.size===0) return true; var ok=false; F.price.forEach(function(r){ var a=r.split('-'); if(p>=+a[0]&&p<=+a[1]) ok=true; }); return ok; }
  function matches(el){
    var c=el.dataset.cat, colr=el.dataset.color, pr=parseFloat(el.dataset.price), sz=(el.dataset.sizes||'').split(',');
    if(cat!=='all' && c!==cat) return false;
    if(F.color.size && !F.color.has(colr)) return false;
    if(F.size.size && !sz.some(function(s){return F.size.has(s.trim());})) return false;
    if(!inPrice(pr)) return false;
    return true;
  }
  function render(){
    var f=items.filter(matches);
    items.forEach(function(el){el.style.display='none';});
    f.forEach(function(el,i){ grid.appendChild(el); el.style.display = i<shown?'':'none'; });
    countEl.textContent=f.length+' produit'+(f.length>1?'s':'');
    emptyEl.style.display=f.length?'none':'block';
    var rest=f.length-shown;
    if(rest>0){ loadmore.parentElement.style.display='block'; loadmore.innerHTML='Charger plus — '+rest+' restant'+(rest>1?'s':'')+' <span>↓</span>'; }
    else loadmore.parentElement.style.display='none';
    var apply=document.getElementById('applyFilter'); if(apply) apply.textContent='Voir '+f.length+' résultat'+(f.length>1?'s':'');
    buildAF();
  }
  function labelFor(f,v){
    if(f==='size') return v==='TU'?'Taille unique':'Taille '+v;
    if(f==='color') return COLORLABEL[v]||v;
    return ({'0-40':'Moins de 40€','40-70':'40 – 70€','70-9999':'70€ et +'})[v]||v;
  }
  function buildAF(){
    var chips=[];
    ['size','color','price'].forEach(function(f){ F[f].forEach(function(v){
      chips.push('<span class="afchip">'+labelFor(f,v)+'<button data-f="'+f+'" data-v="'+v+'" aria-label="Retirer">✕</button></span>');
    });});
    var n=chips.length;
    if(n){ afbar.classList.add('on'); afbar.innerHTML='<span class="aflabel">Filtres</span>'+chips.join('')+'<button class="afclear" id="afclear">Tout effacer</button>'; }
    else { afbar.classList.remove('on'); afbar.innerHTML=''; }
    var b=fbtn.querySelector('.fbadge');
    if(n){ if(!b){ b=document.createElement('span'); b.className='fbadge'; fbtn.appendChild(b);} b.textContent=n; }
    else if(b){ b.remove(); }
    afbar.querySelectorAll('.afchip button').forEach(function(x){ x.addEventListener('click',function(){
      F[x.dataset.f].delete(x.dataset.v);
      document.querySelectorAll('.drawer .chips[data-f="'+x.dataset.f+'"] .chip').forEach(function(c){ if(c.dataset.v===x.dataset.v) c.classList.remove('on'); });
      shown=PAGE_ALL; render();
    });});
    var ac=document.getElementById('afclear'); if(ac) ac.addEventListener('click',clearFilters);
  }
  function clearFilters(){ ['size','color','price'].forEach(function(k){F[k].clear();}); document.querySelectorAll('.drawer .chip').forEach(function(c){c.classList.remove('on');}); shown=PAGE_ALL; render(); }

  /* ---- wiring ---- */
  tabsEl.querySelectorAll('.tab').forEach(function(t){ t.addEventListener('click',function(){ tabsEl.querySelectorAll('.tab').forEach(function(x){x.classList.remove('on');}); t.classList.add('on'); cat=t.dataset.cat; shown=PAGE_ALL; render(); }); });
  loadmore.addEventListener('click',function(){ shown+=8; render(); });
  document.addEventListener('click',function(e){
    var chip=e.target.closest('.drawer .chip'); if(chip){ var f=chip.parentElement.dataset.f, v=chip.dataset.v; chip.classList.toggle('on'); if(F[f].has(v))F[f].delete(v); else F[f].add(v); shown=PAGE_ALL; render(); }
  });
  var drawer=document.getElementById('filterDrawer');
  function openFilter(){ drawer.classList.add('open'); fbtn.setAttribute('aria-expanded','true'); }
  function closeFilter(){ drawer.classList.remove('open'); fbtn.setAttribute('aria-expanded','false'); }
  fbtn.addEventListener('click',openFilter);
  drawer.querySelectorAll('[data-filter-close]').forEach(function(x){x.addEventListener('click',closeFilter);});
  document.getElementById('applyFilter').addEventListener('click',closeFilter);
  document.getElementById('clearFilters').addEventListener('click',clearFilters);

  /* ---- aperçu rapide ---- */
  var qv=document.getElementById('qv'); var qvVariant=null, qvProduct=null;
  /* devise du marché actif (EUR, SEK…) — jamais de symbole en dur */
  function money(c){
    var cur=(window.SMG&&window.SMG.currency)||'EUR';
    try{ return new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:cur}).format(c/100); }
    catch(e){ return (c/100).toFixed(2).replace('.',',')+' '+cur; }
  }
  function openQV(url){
    fetch(url+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(p){
      qvProduct=p;
      var img=document.getElementById('qvimg'); var ex=img.querySelector('.pimg'); if(ex)ex.remove();
      var fr=img.querySelector('.frame'), lb=img.querySelector('.lbl');
      if(p.featured_image){ if(fr)fr.style.display='none'; if(lb)lb.style.display='none'; var im=document.createElement('img'); im.className='pimg'; im.src=p.featured_image; im.alt=p.title; img.appendChild(im); }
      document.getElementById('qvbadge').innerHTML='';
      document.getElementById('qvcat').textContent=p.type||'';
      document.getElementById('qvname').textContent=p.title;
      document.getElementById('qvprice').innerHTML=(p.compare_at_price&&p.compare_at_price>p.price?'<s>'+money(p.compare_at_price)+'</s>':'')+money(p.price);
      var desc=(p.description||'').replace(/<[^>]+>/g,'').slice(0,160);
      document.getElementById('qvdesc').textContent=desc;
      /* tailles : option "Taille"/"Size" */
      var sizeIdx=-1; (p.options||[]).forEach(function(o,i){ var n=(o.name||o).toString().toLowerCase(); if(n==='taille'||n==='size') sizeIdx=i; });
      var box=document.getElementById('qvsizes'), lbl=document.getElementById('qvsizelabel');
      qvVariant=p.variants.find(function(v){return v.available;})||p.variants[0];
      if(sizeIdx<0){ lbl.style.display='none'; box.innerHTML='<button class="qvsz on" disabled>Taille unique</button>'; }
      else {
        lbl.style.display='';
        var vals=[]; p.variants.forEach(function(v){ var val=v.options[sizeIdx]; if(vals.indexOf(val)<0) vals.push(val); });
        box.innerHTML=vals.map(function(s){ var v=p.variants.find(function(x){return x.options[sizeIdx]===s;}); var on=(v&&v.id===qvVariant.id)?' on':''; var dis=(v&&!v.available)?' disabled':''; return '<button class="qvsz'+on+'"'+dis+' data-vid="'+(v?v.id:'')+'">'+s+'</button>'; }).join('');
        box.querySelectorAll('.qvsz:not([disabled])').forEach(function(b){ b.addEventListener('click',function(){ box.querySelectorAll('.qvsz').forEach(function(x){x.classList.remove('on');}); b.classList.add('on'); qvVariant=p.variants.find(function(v){return v.id==b.dataset.vid;}); }); });
      }
      var add=document.getElementById('qvadd'); add.textContent='Ajouter au panier — '+money(p.price); add.disabled=false;
      document.getElementById('qvlink').href=url;
      qv.classList.add('open');
    });
  }
  function closeQV(){ qv.classList.remove('open'); }
  document.addEventListener('click',function(e){
    var q=e.target.closest('.qa[data-quickview]'); if(q){ e.preventDefault(); e.stopPropagation(); openQV(q.dataset.quickview); }
  });
  qv.querySelectorAll('[data-qv-close]').forEach(function(x){x.addEventListener('click',closeQV);});
  document.getElementById('qvadd').addEventListener('click',function(){ if(qvVariant&&window.SMG_CART){ closeQV(); window.SMG_CART.add(qvVariant.id,1); } });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ closeQV(); closeFilter(); } });

  /* ---- catégorie initiale depuis l'URL (ex. ?cat=stickers depuis le menu) ---- */
  (function(){
    var initCat=new URLSearchParams(location.search).get('cat');
    if(!initCat) return;
    var tb=tabsEl.querySelector('.tab[data-cat="'+initCat+'"]');
    if(tb){ tabsEl.querySelectorAll('.tab').forEach(function(x){x.classList.remove('on');}); tb.classList.add('on'); cat=initCat; }
  })();

  render();
})();
